import { ForgeBuilder } from "../components/forge/ForgeBuilder.js";
import { ForgeUsernameGate } from "../components/forge/ForgeUsernameGate.js";
import { RequireAuth } from "../components/RequireAuth.js";
import { useTerminology } from "../lib/terminology.js";

/** POST /v1/forge/boxes: the builder, for a signed-in shopper with a username. */
export function ForgeCreatePage() {
  const { box, item } = useTerminology();
  return (
    <RequireAuth>
      <div className="grid gap-6">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">Forge your own {box.singular}</h1>
          <p className="text-sm text-muted-foreground">
            Name it, pick the {item.plural}, set each pull rate. The price follows from the odds,
            and every open is provably fair.
          </p>
        </div>
        <ForgeUsernameGate>
          <ForgeBuilder />
        </ForgeUsernameGate>
      </div>
    </RequireAuth>
  );
}
